import React from 'react';
import PropTypes from 'prop-types';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import { ChevronDownIcon } from '@domain-group/fe-co-icon';
import { Button } from '@domain-group/fe-co-allhomes-design-system';
import AllhomesAgentCard, { propTypes as agentCardProps } from './allhomes-agent-card';
import * as styles from './allhomes-agent-card-list.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AllhomesAgentCardList = props => {
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  if (props.agents.length === 0 && props.total === 0) {
    return false;
  }
  var titleTag = null;
  if (props.titleTagType === 'h2') {
    titleTag = ___EmotionJSX("h2", {
      css: styles.title
    }, props.title);
  } else {
    titleTag = ___EmotionJSX("h4", {
      css: styles.title
    }, props.title);
  }
  var handleShowMore = () => {
    sendEvent('agent-list.show-more');
    props.onFetchMore();
  };
  return ___EmotionJSX("div", {
    className: props.className
  }, ___EmotionJSX("div", {
    css: styles.titleWrap
  }, titleTag), ___EmotionJSX("div", {
    css: styles.outerWrap
  }, ___EmotionJSX("div", {
    css: styles.innerWrap
  }, props.agents.map(agent => ___EmotionJSX(AllhomesAgentCard, {
    key: agent.id,
    agent: agent,
    onClickCall: props.onClickCall,
    onClickEmail: props.onClickEmail,
    onClickAgentCard: props.onClickAgentCard
  })))), props.hasMore && ___EmotionJSX("div", {
    css: styles.loadMoreWrap
  }, ___EmotionJSX(Button, {
    css: styles.loadMoreButton,
    appearance: "secondaryNeutral",
    size: "small",
    icon: ___EmotionJSX(ChevronDownIcon, {
      size: "small"
    }),
    iconPosition: "right",
    onClick: handleShowMore
  }, "Show more agents")));
};
AllhomesAgentCardList.propTypes = {
  titleTagType: PropTypes.oneOf(['h4', 'h2']),
  className: PropTypes.string,
  agents: PropTypes.arrayOf(agentCardProps.agent),
  hasMore: PropTypes.bool,
  total: PropTypes.number,
  onClickCall: PropTypes.func,
  onClickEmail: PropTypes.func,
  onClickAgentCard: PropTypes.func,
  onFetchMore: PropTypes.func,
  title: PropTypes.string
};
AllhomesAgentCardList.defaultProps = {
  titleTagType: 'h4',
  className: '',
  hasMore: false,
  agents: [],
  total: 0,
  onClickCall: () => {},
  onClickEmail: () => {},
  onClickAgentCard: () => {},
  onFetchMore: () => {},
  title: 'Our Agents'
};
export default AllhomesAgentCardList;